export default __webpack_public_path__ + "static/media/tree.17eb82bb.jpg";